import { LuSparkles } from "react-icons/lu";
import { Box, Button, Card, Heading, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { PageHeader } from "../components/PageHeader";

export function GrantsPage() {
  return (
    <Box minH="full" bg="bg.subtle">
      <PageHeader
        title="Grants"
        description="Track active funding instruments, application status, and reporting milestones across the institute."
        breadcrumbs={[{ label: "CeMMbase", to: "/" }, { label: "Grants" }]}
        actions={
          <Button colorPalette="blue" shadow="sm" disabled>
            <LuSparkles />
            New grant
          </Button>
        }
      />

      <Stack gap={6} px={{ base: 6, sm: 8, lg: 10 }} py={{ base: 6, lg: 8 }}>
        <Card.Root borderWidth="1px" borderStyle="dashed" borderColor="border">
          <Card.Body gap={4} p={{ base: 8, sm: 10 }}>
            <Box>
              <Heading size="xl">Coming soon</Heading>
              <Text mt={2} maxW="3xl" fontSize="sm" color="fg.muted">
                Grant data is not available in CeMMbase yet. This page will show funding instruments, investigators, timelines, and reporting milestones once grant records are connected.
              </Text>
            </Box>

            <SimpleGrid gap={4} columns={{ base: 1, md: 3 }}>
              <Box borderWidth="1px" borderColor="border" px={5} py={5}>
                <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.18em" color="fg.muted">Status</Text>
                <Text mt={2}>No grant records available yet</Text>
              </Box>
              <Box borderWidth="1px" borderColor="border" px={5} py={5}>
                <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.18em" color="fg.muted">Planned content</Text>
                <Text mt={2}>Portfolio overview, milestones, reporting status</Text>
              </Box>
              <Box borderWidth="1px" borderColor="border" px={5} py={5}>
                <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.18em" color="fg.muted">Availability</Text>
                <Text mt={2}>Coming soon</Text>
              </Box>
            </SimpleGrid>
          </Card.Body>
        </Card.Root>
      </Stack>
    </Box>
  );
}
